'use strict';


/**
 * Render function.
 *
 * @this Object
 *
 * @param {Node} $node DOM element of list item
 */
function render ( $node ) {
    //var additionalInfo = '';

    $node.className = 'content-item-movie';

    $node.$shadow = $node.appendChild(document.createElement('div'));
    $node.$shadow.className = 'content-item-movie-shadow';

    $node.$container = $node.appendChild(document.createElement('div'));

    if ( this.data.icon ) {
        $node.$container.hasImage = false;
        $node.$container.className = 'content-item-movie-container';

        if ( typeof this.data.icon === 'string' ) {
            $node.$container.style.backgroundImage = 'url(' + this.data.icon + ')';
        } else {
            $node.$container.style.backgroundImage = 'url("' + this.data.icon.normal + '")';
        }
    } else if ( this.data.image ) {
        $node.$container.hasImage = true;
        $node.$container.style.backgroundImage = 'url("' + this.data.image.normal + '")';
        $node.$container.className = 'content-item-movie-container content-item-movie-container--image';
    }

    $node.$container.style.backgroundColor = this.data.colors.background;

    $node.$title = $node.$container.appendChild(document.createElement('div'));
    $node.$title.className = 'content-item-movie-title';
    $node.$title.innerText = this.data.name;

    $node.$description = $node.$container.appendChild(document.createElement('div'));
    $node.$description.className = 'content-item-movie-description';

    if ( this.data.description ) {
        $node.$description.innerText = this.data.description;
    }

    //$node.$additionalInfo = $node.appendChild(document.createElement('div'));
    //$node.$additionalInfo.className = 'content-item-movie-additional-info';

    /*if ( this.data.age ) {
        additionalInfo = this.data.age;
    }*/

    /*if ( this.data.year ) {
        if ( additionalInfo.length > 0 ) {
            additionalInfo += ' • ';
        }
        additionalInfo += this.data.year;
    }*/

    /*if ( this.data.duration ) {
        if ( additionalInfo.length > 0 ) {
            additionalInfo += ' • ';
        }
        additionalInfo += this.data.duration;
    }*/

    //$node.$additionalInfo.innerText = additionalInfo;

    // $node.$card = $node.appendChild(document.createElement('div'));
    // $node.$card.className = 'content-item-video-card';
    // $node.$card.style.backgroundColor = this.data.colors.background;

    // $node.$icon = $node.appendChild(document.createElement('div'));
    // $node.$focusIcon = $node.appendChild(document.createElement('div'));

    //$node.$name = $node.$card.appendChild(document.createElement('div'));
    //$node.$description = $node.appendChild(document.createElement('div'));

    // $node.$icon.className = 'content-item-movie-icon';
    //
    // if ( this.data.icon ) {
    //     $node.$icon.style.backgroundImage = 'url("' + this.data.icon.normal + '")';
    // } else if ( this.data.image ) {
    //     $node.$icon.style.backgroundImage = 'url("' + this.data.image.normal + '")';
    // }

    // $node.$name.className = 'content-item-video-name';
    // $node.$name.innerText = this.data.name;
    // $node.$name.style.color = this.data.colors.splashFont;

    //$node.$description.className = 'hidden';
    //$node.$description.innerText = this.data.description;

    // setTimeout(function () {
    //     $node.coords = $node.getBoundingClientRect();
    //     $node.coords.offset = 20 + $node.coords.width;
    // }, 0);
}

module.exports = {
    render: render,

    focus: function ( $node ) {
        $node.$shadow.className = 'content-item-movie-shadow--focus';
        $node.$container.className = 'content-item-movie-container--focus' +
            ( $node.$container.hasImage ? ' content-item-movie-container--image' : '' );
        $node.$title.className = 'content-item-movie-title--focus';
        $node.$description.className = 'content-item-movie-description--focus';
        //$node.$additionalInfo.className = 'content-item-movie-additional-info--focus';

        if ( !$node.$container.hasImage ) {
            $node.$container.style.backgroundImage = 'url("' + this.data.icon.active + '")';
        }
    },

    blur: function ( $node ) {
        $node.$shadow.className = 'content-item-movie-shadow';
        $node.$container.className = 'content-item-movie-container' +
            ( $node.$container.hasImage ? ' content-item-movie-container--image' : '' );
        $node.$title.className = 'content-item-movie-title';
        $node.$description.className = 'content-item-movie-description';
        //$node.$additionalInfo.className = 'content-item-movie-additional-info';

        if ( !$node.$container.hasImage ) {
            $node.$container.style.backgroundImage = 'url("' + this.data.icon.normal + '")';
        }
    }
};
